import React from "react";
// Same react-icons/md family already used throughout ProviderProductWizard.jsx
// (MdFilterList, MdCategory, ...) -- no new icon library added.
import { MdCheck } from "react-icons/md";

// Shared "select which values are active for this filter" picker -- extracted
// from ProviderFiltersEditor.jsx so Provider AND Seller (editProduct.jsx)
// render the exact same UI (buttons with aria-pressed + a check icon when
// selected, "Select all" reflecting its own state) instead of two separate
// implementations. Purely presentational: every def/value's "is it selected"
// comes from the caller's own real state via `selected` -- this component
// never keeps a visual-only selection state of its own.
//
// Props:
//   defs           -- [{ filterId, key, name, values: [{ value, label }] }]
//   selected       -- { [filterId]: string[] } (the caller's real selection state)
//   onToggleValue(def, value) -- toggle one value for one filter
//   onToggleAll(def)          -- toggle "select all" for one filter
//   selectAllLabel -- already-translated "Select all" text. A plain string
//     (not a t() function) so this component stays fully independent of
//     which i18n namespace/catalog a given caller uses (Provider's
//     "providerProductWizard" vs Seller's "editProduct"/"editEditProduct") --
//     every other label here (def.name, value.label) is already translated
//     upstream by toDefs()/getFilTranslate, so this is the only string this
//     component itself needs handed to it.
const FilterValuePicker = ({ defs, selected, onToggleValue, onToggleAll, selectAllLabel }) => {
  const chosen = (def) => selected[def.filterId] || [];
  const isAllSelected = (def) => def.values.length > 0 && chosen(def).length === def.values.length;

  return (
    <>
      {defs.map((def) => {
        const allSelected = isAllSelected(def);
        return (
          <fieldset key={def.filterId} className="form-group provider-filters__group">
            <legend className="text-muted h6">{def.name}</legend>
            <button
              type="button"
              className={`provider-filters__select-all${allSelected ? " provider-filters__select-all--active" : ""}`}
              aria-pressed={allSelected}
              onClick={() => onToggleAll(def)}
            >
              {allSelected && <MdCheck className="provider-filters__check" aria-hidden="true" />}
              {selectAllLabel}
            </button>
            <div className="provider-filters__values">
              {def.values.map((v) => {
                const selectedValue = chosen(def).includes(v.value);
                return (
                  <button
                    key={v.value}
                    type="button"
                    className={`provider-filters__value${selectedValue ? " provider-filters__value--selected" : ""}`}
                    aria-pressed={selectedValue}
                    onClick={() => onToggleValue(def, v.value)}
                  >
                    {selectedValue && <MdCheck className="provider-filters__check" aria-hidden="true" />}
                    {v.label}
                  </button>
                );
              })}
            </div>
          </fieldset>
        );
      })}
    </>
  );
};

export default FilterValuePicker;
